import { render } from "./phoneInput.vue?vue&type=template&id=3b4858cc&scoped=true"
import script from "./phoneInput.vue?vue&type=script&lang=js"
export * from "./phoneInput.vue?vue&type=script&lang=js"

import "./phoneInput.vue?vue&type=style&index=0&id=3b4858cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b4858cc"]])

export default __exports__